var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9087 6.5C11.9087 7.42509 11.6815 8.26904 11.227 9.03183C10.7888 9.79463 10.1721 10.4114 9.37684 10.882C8.58158 11.3365 7.73764 11.5637 6.845 11.5637C5.95237 11.5637 5.10842 11.3365 4.31317 10.882C3.51791 10.4114 2.90118 9.79463 2.46298 9.03183C2.00855 8.26904 1.78133 7.42509 1.78133 6.5C1.78133 5.5749 2.00855 4.73096 2.46298 3.96816C2.90118 3.20537 3.51791 2.58864 4.31317 2.11798C5.10842 1.66354 5.95237 1.43633 6.845 1.43633C7.73764 1.43633 8.58158 1.66354 9.37684 2.11798C10.1721 2.58864 10.7888 3.20537 11.227 3.96816C11.6815 4.73096 11.9087 5.5749 11.9087 6.5ZM0.612793 6.5C0.629023 7.63608 0.904928 8.67478 1.44051 9.6161C1.99232 10.5574 2.75512 11.3202 3.7289 11.9045C4.71891 12.4563 5.75761 12.7322 6.845 12.7322C7.93239 12.7322 8.9711 12.4563 9.96111 11.9045C10.9349 11.3202 11.6977 10.5574 12.2495 9.6161C12.7851 8.67478 13.061 7.63608 13.0772 6.5C13.061 5.36392 12.7851 4.32522 12.2495 3.38389C11.6977 2.44257 10.9349 1.67977 9.96111 1.0955C8.9711 0.543694 7.93239 0.267789 6.845 0.267789C5.75761 0.267789 4.71891 0.543694 3.7289 1.0955C2.75512 1.67977 1.99232 2.44257 1.44051 3.38389C0.904928 4.32522 0.629023 5.36392 0.612793 6.5ZM6.26073 3.18914V6.5C6.26073 6.71098 6.35 6.87328 6.52852 6.98689L8.8656 8.54494C9.17397 8.72347 9.44176 8.66667 9.66897 8.37453C9.8475 8.06617 9.7907 7.79838 9.49856 7.57116L7.42927 6.18352V3.18914C7.39681 2.83208 7.20206 2.63733 6.845 2.60487C6.48795 2.63733 6.29319 2.83208 6.26073 3.18914Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.69,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b59cd050fd346ab31d8c27e26f30686c.svg";
export { ForwardRef as ReactComponent };